import React, { useState, useEffect } from 'react';
import { IconScrollDown } from '../../../assets/icons';
import { ImageDesktopBlue, ImageGamingJoy, ImageGamingRoom, ImageMobile, ImageProgramming } from '../../../assets/images';

const image = [ImageProgramming, ImageMobile, ImageDesktopBlue, ImageGamingJoy];
const title = ['Web Development', 'Mobile Development', 'Server Side Development', 'UI-UX Design'];
const description = ['Let us make your idea come true', 'Up your company sales', 'Give trust to client', 'Make your own design'];

function MainHeader({ onClickMouse }) {

  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    let isAuto = true;
    let delay = 10000;

    setTimeout(() => {
      if(isAuto) {
        if(imageIndex < image.length - 1) {
          setImageIndex(imageIndex + 1);
        } else {
          setImageIndex(0);
        }
      }
    }, delay);
    
    return () => isAuto = false;
    
  }, [imageIndex]);

  return (
    <div id="MainHeader">
      <img src={image[imageIndex]} alt="header" />
      <div className="header-overlay">
        <h1>{title[imageIndex]}</h1>
        <p>{description[imageIndex]}</p>
      </div>
      <div className="header-action">
        {image.map((image, index) => (
          <SquarePaginate 
            key={index}
            image={image}
            active={imageIndex === index ? true : false}
            onClick={() => setImageIndex(index)}
          />
        ))}
      </div>
      <div className="header-footer">
        <MouseDownButton onClick={onClickMouse} />
      </div>
    </div>
  );
}

const SquarePaginate = ({ onClick, image, active }) => {
  return (
    <button className={`square-paginate ${active && 'square-paginate-active'}`} onClick={onClick}>
      <img src={image} alt="thumbnail" />
    </button>
  )
}

const MouseDownButton = ({ onClick }) => {
  return (
    <button className="scroll-down-btn" onClick={onClick}>
      <img src={IconScrollDown} />
    </button>
  )
}

export default MainHeader;